export default __webpack_public_path__ + "static/media/patricis_skins.0c4983ed.svg";